// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"303c2690","453":"41cf231f","455":"4bf70e86"}[chunkId] + ".chunk.js";
};